import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';

/**
 * A LocationStrategy that prevents Angular's router from
 * interfering with the AEM page's URL.
 */
@Injectable()
class NoopLocationStrategy extends LocationStrategy {
  path(): string { return ''; }
  prepareExternalUrl(internal: string): string { return internal; }
  pushState(): void {}
  replaceState(): void {}
  forward(): void {}
  back(): void {}
  onPopState(): void {}
  getBaseHref(): string { return ''; }
  getState(): unknown { return {}; }
}

export const provideNoopLocationStrategy = () => ({
  provide: LocationStrategy,
  useClass: NoopLocationStrategy
});